import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '@/lib/utils';

/**
 * Standard "Volver" button used in page headers.
 * Solid bordered chip with strong contrast, works in light + dark.
 *
 * Usage:
 *   <BackButton to="/dashboard" />
 *   <BackButton to="/dashboard" label="Volver al panel" />
 *   <BackButton onClick={() => history.back()} />
 */
export default function BackButton({
  to,
  label = 'Volver',
  onClick,
  className = '',
  size = 'sm',
  testId = 'back-btn',
  showLabelOnMobile = false,
}) {
  const baseCls = cn(
    // Solid contrast: emerald accent border + bg subtle, never blanco-sobre-blanco
    'border border-slate-600 bg-slate-700/40 text-slate-100',
    'hover:bg-emerald-600 hover:text-white hover:border-emerald-500',
    'active:bg-emerald-700 focus-visible:ring-2 focus-visible:ring-emerald-500',
    'transition-colors',
    className,
  );

  const inner = (
    <>
      <ArrowLeft className="w-4 h-4 sm:mr-2" />
      <span className={showLabelOnMobile ? '' : 'hidden sm:inline'}>{label}</span>
    </>
  );

  if (onClick) {
    return (
      <Button variant="outline" size={size} onClick={onClick} className={baseCls} data-testid={testId}>
        {inner}
      </Button>
    );
  }
  return (
    <Link to={to || '/dashboard'} aria-label={label}>
      <Button variant="outline" size={size} className={baseCls} data-testid={testId}>
        {inner}
      </Button>
    </Link>
  );
}
